var hasFired = false;

(function($){

//  function adjustIframeWidths(){
//
//    // first grab the actual viewable width
//    function getWindowHeight() {
//        return $(window).height();
//    }
//    var windowWidth = $(window).width();
//    var windowHeight = $(window).height();
//    var modals;
//    var modal;
//    var gallery;
//    var container;
//    var heightAdjustment;
//    var desiredContentWidth;
//    var desiredContentHeight;
//    var desiredIframeWidth;
//    var containerWidth;
//    var containerHeight;
//    var halfwidth;
//
//    // finally we resize the before and after iframe
//    modals = $('#modal_bna, #modal_brow, #modal_chin, #modal_neck, #modal_chest, #before_after');
//    modals.each(function(){
//      modal = $(this);
//      gallery = modal.data('gallery');
//      heightAdjustment = 0.4;
//      desiredContentWidth = windowWidth * 0.9;
//      if (desiredContentWidth > 900){
//        desiredContentWidth = 900;
//      }
//      if (windowWidth < 800 && windowWidth > 600) {
//        heightAdjustment = 0.6;
//      }
//
//      desiredContentHeight = desiredContentWidth * heightAdjustment;
//      desiredIframeWidth = desiredContentWidth - 25;
//      modalWidth = desiredContentWidth + 48;
//      modalHeight = false;
//      modal.width(modalWidth);
//      halfwidth = parseInt(parseInt(modal.css('width')) / 2) * -1.1;
//
//      // adjusted width = windowHeight * original width / original height
//      function resizeGalleryModal() {
//        getWindowHeight();
//        var docHeight = $(document).height();
//        var docWidth = $(document).width();
//        var aspectWidth = 770;
//        var aspectHeight = 415;
//        var aspectRatio = aspectWidth / aspectHeight;
//
//        if(windowHeight > windowWidth){ // portrait mode
//          // alert('THIS IS IN PORTRAIT VIEW!');
//          modalWidth = desiredContentWidth;
//          desiredContentWidth = docWidth;
//          desiredIframeWidth = desiredContentWidth;
//          heightAdjustment = 0.565;
//          desiredContentHeight = desiredContentWidth * heightAdjustment;
//          modal.css({
//            'padding' : 0,
//            'padding-top' : 30,
//            'top' : 100
//          });
//        }
//        else { // landscape mode
//          // alert('THIS IS IN LANDSCAPE VIEW!');
//
//          // Doing: Setting the content height to the full window height
//          desiredContentHeight = windowHeight - 35;
//          //console.log('Content Height: ' + desiredContentHeight);
//          //console.log('Window Height: ' + windowHeight);
//
//          // Doing: Calc'ing the content width based on content height and aspect ratio
//          desiredContentWidth = Math.floor(desiredContentHeight * aspectRatio);
//          //console.log('Content Width: ' + desiredContentWidth);
//
//          // Doing: Setting modal height to content height
//          modalHeight = windowHeight;
//          //console.log('Modal Height: ' + modalHeight);
//
//          // Doing: Setting modal width to content width
//          modalWidth = desiredContentWidth + 2;
//          //console.log('Modal Width: ' + modalWidth);
//
//          // Doing: Setting iFrame width to content width
//          desiredIframeWidth = desiredContentWidth;
//          //console.log('Iframe Width: ' + desiredIframeWidth);
//
//          modal.width(modalWidth);
//          heightAdjustment = 0;
//          halfwidth = parseInt(parseInt(modal.css('width')) / 2) * -1.08;
//          modal.css({
//            'top' : 0,
//            'padding' : '30px 0 15px'
//          });
//        }
//      }
//
//      //now adjust for mobile
//      if (windowWidth <= 600){
//          resizeGalleryModal();
//      }
//      modal.css('margin-left',halfwidth);
//      if (modalHeight){
//          modal.height(modalHeight);
//      }
//      modal.append('<iframe id="'+modal.attr("id")+'_iframe" class="gallery_iframe" width="'+desiredContentWidth+'" height="'+desiredContentHeight+'" src="/gallery-new/'+gallery+'?width='+desiredIframeWidth+'" style="border:none; overflow: hidden; margin: 0 auto;"></iframe>');
//    });
//  }

//  $(window).on("orientationchange", function() { // trigger when changing from landscape to portrait modes
//    if (!hasFired){ // the event has not triggered
//      resizeGalleryModal();
//    }
//    id = setTimeout(500); // set event timer
//    clearTimeout(id); // clear event timer
//    hasFired = true; // the event has triggered
//    return false;
//  });

  function resizeIframe(ifrm){
    if (ifrm.length > 0 && ifrm.hasClass('results-page-iframe')){
      console.log('resize me');
      var heightAdjustment;
      var ifrmWidth;
      var desiredContentWidth;
      var desiredContentHeight;
      var ifrmHeight;
      var smIfrm;
      var gallery = $("#gallery_id").data('gallery');
      if (ifrm.hasClass('hide-desktop')){ // phone iframe
        $(window).unbind('resize');
        heightAdjustment = 0.6;
        ifrmWidth = ifrm.width();
        desiredContentWidth = ifrmWidth - 40;
        desiredContentHeight = desiredContentWidth * heightAdjustment + 32;
        ifrmHeight = ifrmWidth * heightAdjustment;
        ifrm.css('height', ifrmHeight);
        smIfrm = $('<iframe id="gallery_iframe_large" class="results-page-iframe hide-desktop" width="100%" height="'+desiredContentHeight+'" src="/gallery-'+gallery+'?width='+desiredContentWidth+'"></iframe>');
        ifrm.empty().append(smIfrm);
        smIfrm.css({'width':'100%', 'height': 'auto', 'min-height': '340px', 'overflow':'hidden'});
        $(window).on('resize', function(){
           resizeIframe(ifrm);
        });
      }
      else { // non-phone iframe
        heightAdjustment = 0.485;
        ifrmWidth = ifrm.width();
        ifrmHeight = ifrmWidth * heightAdjustment;
        ifrm.css('height', ifrmHeight);
        //console.log($("#standalone-gallery img"));
      }
    }
  }

  $(document).ready(function(){

    var largeIframe = $("#gallery_iframe_large");
    var smallIframe = $("#gallery_iframe_small");
    resizeIframe(largeIframe);
    resizeIframe(smallIframe);

    // Auto scrolling slideshow pagers
    $('.auto-scrolling-cycle-slideshow').on('cycle-before',function(){
      var jSlideshow = $(this);
      var jPager = $(jSlideshow.data('cyclePager'));
      var jPagerParent = jPager.parent();

      // disabling this feature due it its undesired behavior on mobile devices
      // if(jPagerParent.size() > 0){
      //  jPagerParent.animate({
      //    scrollTop:jPager.find('.'+jSlideshow.data('cyclePagerActiveClass')).offset().top-jPager.offset().top
      //  });
      // }
    });


    // Control scrollable area height
    $('.photo_gallery_top_row').each(function(){
      var jThisGallery = $(this);
      var jPagerColumn = jThisGallery.find('.photo_gallery_scroll_parent');
      var jImageColumn = jThisGallery.find('.photo_gallery_image_parent');
      jPagerColumn
        .removeClass(jPagerColumn.data('iframeRemoveClasses'))
        .addClass(jPagerColumn.data('iframeAddClasses'));
      jImageColumn
        .removeClass(jImageColumn.data('iframeRemoveClasses'))
        .addClass(jImageColumn.data('iframeAddClasses'));
  
      jPagerColumn.attr('class');
      $(window).on('resize load switchtab', triggerResize = function(){
        if(jImageColumn.height() == 0){
          setTimeout(triggerResize, 200);
        }
        jPagerColumn.height(jImageColumn.height());
      });
    });

  });
}(jQuery));